export function validateNumber(number) {
  let convertedNumber = Number(number);
  if(isNaN(convertedNumber)) {
      return 100;
  }
  if(convertedNumber > 100) {
      return 100;
  }
  return convertedNumber;
}